import { dataCurta, pct } from '../format';

type Ponto = { data: string; valor: number | null };

const W = 300;
const H = 110;
const PAD = { t: 8, r: 8, b: 20, l: 30 };

/**
 * Linha do tempo em SVG. Valores nulos (dias sem ação cadastrada) quebram a linha em vez de virar zero:
 * "não havia nada" é diferente de "estava em 0%".
 */
export function GraficoLinha({ pontos, cor = 'var(--verde)', rotulo }: { pontos: Ponto[]; cor?: string; rotulo: string }) {
  const comValor = pontos.filter((p) => p.valor !== null);
  if (pontos.length < 2 || comValor.length === 0) {
    return <p class="vazio">Ainda não há dados suficientes para o gráfico.</p>;
  }

  const x = (i: number) => PAD.l + (i / (pontos.length - 1)) * (W - PAD.l - PAD.r);
  const y = (v: number) => PAD.t + (1 - v / 100) * (H - PAD.t - PAD.b);

  // Um trecho (M ... L ...) para cada sequência contínua de valores.
  let d = '';
  let aberto = false;
  pontos.forEach((p, i) => {
    if (p.valor === null) {
      aberto = false;
      return;
    }
    d += `${aberto ? 'L' : 'M'}${x(i).toFixed(1)},${y(p.valor).toFixed(1)} `;
    aberto = true;
  });

  const ultimoIdx = pontos.map((p) => p.valor !== null).lastIndexOf(true);
  const ultimo = pontos[ultimoIdx]!;
  const primeiro = pontos[0]!;
  const final = pontos[pontos.length - 1]!;

  return (
    <figure class="grafico">
      <svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={`${rotulo}: último valor ${pct(ultimo.valor)} em ${dataCurta(ultimo.data)}`}>
        {[0, 50, 100].map((v) => (
          <g key={v}>
            <line x1={PAD.l} x2={W - PAD.r} y1={y(v)} y2={y(v)} class={v === 50 ? 'linha-grade linha-grade-meio' : 'linha-grade'} />
            <text x={PAD.l - 5} y={y(v) + 3} class="eixo" text-anchor="end">
              {v}%
            </text>
          </g>
        ))}
        {/* style (e não o atributo): só ele aceita var(--cor) e acompanha o tema */}
        <path d={d} fill="none" style={{ stroke: cor }} stroke-width="2" stroke-linejoin="round" stroke-linecap="round" />
        <circle cx={x(ultimoIdx)} cy={y(ultimo.valor!)} r="3.5" style={{ fill: cor }} />
        <text x={PAD.l} y={H - 5} class="eixo">{dataCurta(primeiro.data)}</text>
        <text x={W - PAD.r} y={H - 5} class="eixo" text-anchor="end">{dataCurta(final.data)}</text>
      </svg>
    </figure>
  );
}
